import React, { useRef, useState, useEffect } from "react";
import ErrorMessage from "components/ErrorMessage";
import { AiFillCamera } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import { apiPut } from "../../utils/apiFetch";
import OButton from "components/reusable/OButton";
import { useNavigate, useLocation } from "react-router-dom";
import apiPath from "../../utils/apiPath";
import { apiGet } from "../../utils/apiFetch";
import useToastContext from "hooks/useToastContext";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import OFile from "components/reusable/OFile";
import { validationRules } from "utils/constants";
const ViewBlog = (item) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [profilePic, setProfilePic] = useState(location?.state?.file || null);
  const [uploadedFiles, setUploadedFiles] = useState(
    location?.state?.files || null
  );
  const [addMerchantLoading, setAddMerchantLoading] = useState(false);
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [editData, setEditData] = useState(location.state);
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    souldFocusError: true,
    defaultValues: {
      // title: location?.state?.title || "",
      // authorName: location?.state?.authorName || "",
      // description: location?.state?.description || "",
      // // categoryId: location?.state?.category || "",
      // // title: location?.state?.title || "",
      // image: location?.state?.file || "",
    },
  });

  const handleFileChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(image);
    if (isValidImage) {
      setProfilePic(image);
    } else {
      setProfilePic(null);
    }
  };

  const validateFiles = (profilePic) => {
    let picError = "";
    const supportedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!isEmpty(supportedTypes.includes(profilePic.type))) {
      picError = "Only jpeg, jpg and png are supported.";
    }
    if (picError) {
      setProfilePicError(picError);
      return false;
    } else {
      setProfilePicError("");
      return true;
    }
  };

  const getBack = () => {
    setRedirect(true);
    navigate("/blogs");
  };

  const getCategories = async () => {
    const path = apiPath.categoryList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      setCategories(response?.docs);
    }
  };
  
  const getSubCategories = (categoryId,categories) => {
    const category = categories.filter((item) => {
      return item?._id === categoryId;
    });
  
     setSubCategories(category[0]?.subcategories);
    
  };
  useEffect(() => {
    getCategories()
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue("title", editData.title ?? "");
      setValue("categoryId", editData?.category ?? "");
      setValue("subCategoryId", editData?.subCategory ?? "");
      setValue("authorName", editData?.authorName ?? "");
      setValue("description", editData?.description ?? "");
    }

  }, [editData]);

  useEffect(() => {  
      getSubCategories(editData?.category,categories)
  }, [editData,categories.length]);

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <h2 className="font-medium text-black dark:text-white mb-3 text-xl">
          View Blog
        </h2>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="title"
                  id="title"
                  disabled
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("title", {
                    required: t("VALIDATION_TITLE_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_TITLE_MIN_LENGTH")
                        : val.length > 30
                        ? t("VALIDATION_TITLE_MAX_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("title", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="title"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_TITLE")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.title?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  disabled
                  name="authorName"
                  id="authorName"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("authorName", {
                    required: t("VALIDATION_AUTHOR_REQUIRED"),
                    pattern: {
                      value: validationRules.characters,
                      message: t("VALIDATION_AUTHOR_PATTERN"),
                    },
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_AUTHOR_MIN_LENGTH")
                        : val.length > 30
                        ? t("VALIDATION_AUTHOR_MAX_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("authorName", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="authorName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_AUTHOR_NAME")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.authorName?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="categoryId"
                  disabled
                  name="categoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("categoryId", {
                    required: t("VALIDATION_SELECT_CATEGORY"),
                    onChange: (e) => {
                      getSubCategories(e.target.value);
                    },
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_CATEGORY")}
                  </option>
                  {categories &&
                    categories.length !== 0 &&
                    categories?.map(({ title, _id }) => (
                      <option
                        key={_id}
                        value={_id}
                        selected={_id === editData?.category}
                      >
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="name"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORY")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.categoryId?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                disabled
                  id="subCategoryId"
                  name="subCategoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("subCategoryId", {
                    required: t("VALIDATION_SELECT_SUB_CATEGORY"),
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_SUB_CATEGORY")}
                  </option>
                  {subCategories &&
                    subCategories.length !== 0 &&
                    subCategories?.map(({ title, _id }) => (
                      <option
                        key={_id}
                        value={_id}
                        selected={_id === editData?.subCategory}
                      >
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="subCategoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_SUBCATEGORIES")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.subCategoryId?.message} />
              </div>
            </div>
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                disabled
                  type="text"
                  name="description"
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={151}
                  {...register("description", {
                    required: t("VALIDATION_DESCRIPTION_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_DESCRIPTION_MIN_LENGTH")
                        : val.length > 150
                        ? t("VALIDATION_DESCRIPTION_MAX_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("description", value, {
                      shouldValidate: true,
                    });
                  }}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.description?.message} />
              </div>
            </div>

            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                {t("O_UPLOADED_IMAGE_VIDEO")}
              </h3>
            </div>
            {uploadedFiles?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedFiles?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : t("O_N/A")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBlog;
